export enum ApprovalStatuses {
  /**
   * Одобрен
   */
  APPROVED = 'approved',

  /**
   * Не одобрен
   */
  NOT_APPROVED = 'not_approved',

}

export const ApprovalStatusesTranslate: Record<string, string> = {
  [ApprovalStatuses.APPROVED]: 'Одобрен',
  [ApprovalStatuses.NOT_APPROVED]: 'Не одобрен',
};

export const approval_statuses = Object.keys(
  ApprovalStatusesTranslate,
).map(
  (f: string) => ({ text: ApprovalStatusesTranslate[f], value: f }),
);
